<p-button 
    icon="fas fa-cog"
    [rounded]="true"
    [text]="true"
    [pTooltip]="l('::Configure')"
    tooltipPosition="left"
    (onClick)="onClick($event)" />